// extracted by mini-css-extract-plugin
export default {"stopwatch":"Stopwatch_stopwatch__nDt2o","clockWrapper":"Stopwatch_clockWrapper__sqyzz","title":"Stopwatch_title__jEdwg"};